import { Link, useNavigate } from "react-router-dom";
import "./Style/Navbar.css";
import BackButton from "./BackButton";


const Navbar = () => {
  

    


  return (
    <>
    
      <nav>
        <ul>

          <li>
            <Link to="/">
              <img src="/logo.png" className="logo" alt="Study Logo" />
            </Link>
          </li>


          <li className="center-links">
            <Link to="/" className="app-name">JEE Prep App</Link>
            <Link to="/">Home</Link>
            <Link to="/about">About</Link>
            <Link to="/contact">Contact</Link>

                    
          </li>

         


         
        </ul>
      </nav>
      <BackButton />
     
    </>
  );
};

export default Navbar;